import { motion, useReducedMotion } from "framer-motion";

// A tiny glowing train that drives across the section on its own rail.
// Runs every `every` seconds; pure transform animation, pauses off-screen.
export const TrainRunner = ({ className = "", every = 14, dur = 9 }) => {
  const reduce = useReducedMotion();
  if (reduce) return null;
  const cars = [
    { w: 34, engine: true },
    { w: 26 },
    { w: 26 },
  ];
  return (
    <div
      aria-hidden="true"
      data-testid="train-runner"
      className={`pointer-events-none absolute inset-x-0 bottom-6 z-10 overflow-hidden ${className}`}
    >
      {/* rail */}
      <div className="absolute inset-x-0 bottom-1 h-px bg-cyan/25" />
      <motion.div
        className="absolute bottom-1 flex items-end gap-1"
        initial={{ x: "-12vw" }}
        animate={{ x: "112vw" }}
        transition={{ duration: dur, repeat: Infinity, repeatDelay: every, ease: "linear" }}
      >
        {cars.map((c, i) => (
          <div
            key={i}
            className="relative rounded-[5px] border border-volt/40 bg-espresso/90"
            style={{ width: c.w, height: c.engine ? 18 : 15, boxShadow: "0 0 12px rgba(233,180,76,0.25)" }}
          >
            {/* windows */}
            <div className="absolute inset-x-1 top-1 flex gap-1">
              {Array.from({ length: c.engine ? 2 : 3 }).map((_, w) => (
                <span key={w} className="h-1.5 flex-1 rounded-[2px] bg-volt/80" style={{ boxShadow: "0 0 6px rgba(233,180,76,0.8)" }} />
              ))}
            </div>
            {/* wheels */}
            <div className="absolute -bottom-1 inset-x-1 flex justify-between">
              {[0, 1].map((w) => (
                <span key={w} className="h-1.5 w-1.5 rounded-full bg-ink/80" />
              ))}
            </div>
            {c.engine && (
              <span className="absolute -right-0.5 top-1/2 h-2 w-2 -translate-y-1/2 rounded-full bg-gold-soft" style={{ boxShadow: "0 0 10px rgba(255,220,120,0.95)" }} />
            )}
          </div>
        ))}
      </motion.div>
    </div>
  );
};
